var _path, _path2, _g, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptopphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 42L0 42",
    stroke: "white",
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_234_4955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 7,
    width: 52,
    height: 39
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 45.5V7H53.6667V15.1667H31.5V45.5H2.33333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_234_4955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 11.6667H48C48.5523 11.6667 49 12.1144 49 12.6667V38.6667C49 39.219 48.5523 39.6667 48 39.6667H8C7.44772 39.6667 7 39.219 7 38.6667V12.6667C7 12.1144 7.44772 11.6667 8 11.6667Z",
    stroke: "white",
    strokeWidth: 1.2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3333 46.6667L38.3333 46.6667C37.7811 46.6667 37.3333 46.219 37.3333 45.6667L37.3333 22C37.3333 21.4477 37.7811 21 38.3333 21L42.9333 21L45.7333 21L50.3333 21C50.8856 21 51.3333 21.4477 51.3333 22L51.3333 45.6667C51.3333 46.219 50.8856 46.6667 50.3333 46.6667Z",
    stroke: "white",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopphone);
export default __webpack_public_path__ + "static/media/laptopphone.8a04ac32ce10589873a72cc8388fc7de.svg";
export { ForwardRef as ReactComponent };